/* ============================================================
   Labella.hu – termékkártya képváltó gomb
   Betöltés: snippets/theme-variables.liquid

   A téma a második (bútor) fotót csak 1025 px felett, egérrel
   rávive mutatja meg – érintőképernyőn tehát sehogy. Ez a szkript
   minden olyan termékkártyára kitesz egy kis gombot, amelyiknek
   van második képe, és a gomb átkapcsol a két kép között.

   A kártya HTML-jéhez nem nyúlunk: a gombot itt tesszük hozzá,
   így a téma frissítése sem írja felül. A stílus:
   assets/labella-card-toggle.css
   ============================================================ */
(function () {
  'use strict';

  var LABEL_A = 'Bútor';
  var LABEL_B = 'Enteriőr';
  var ARIA = 'Másik kép megjelenítése';
  var ICON =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
    '<rect x="1.35" y="6.05" width="11.1" height="11.1" rx="2.2" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M6.6 6.05V4.9c0-1.2 1-2.2 2.2-2.2h7.45c1.2 0 2.2 1 2.2 2.2v7.45c0 1.2-1 2.2-2.2 2.2H15.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  function addButton(box) {
    if (!box || box.querySelector('.labella-img-toggle')) return;
    if (!box.querySelector('.product-second-img')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'labella-img-toggle';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', ARIA);
    btn.setAttribute('tabindex', '0');
    btn.innerHTML =
      ICON +
      '<span class="lbl-a">' + LABEL_A + '</span>' +
      '<span class="lbl-b">' + LABEL_B + '</span>';
    box.appendChild(btn);
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('.product-card-img');
    for (var i = 0; i < nodes.length; i++) addButton(nodes[i]);
  }

  /* A második kép lustán töltődik. Amíg rejtve van, a lazysizes nem
     tölti be, ezért kapcsoláskor rásegítünk. */
  function preload(box) {
    var imgs = box.querySelectorAll('.product-second-img img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.className.indexOf('lazyload') === -1) continue;
      if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
        window.lazySizes.loader.unveil(img);
      } else {
        img.className += ' lazypreload';
      }
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || t.nodeType !== 1 || !t.closest) return;
      var btn = t.closest('.labella-img-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var box = btn.closest('.product-card-img');
      if (!box) return;
      var on = box.classList.toggle('labella-swapped');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) preload(box);
    },
    true
  );

  function start() {
    scan();
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        scan();
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();